
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Fourtyseater() {



    const cardData =
    {
        keyword: '40 Seater AC Bharat Benz on Rent in Pune',
        heading: 'Amruta Travels: 40 Seater AC Bharat Benz on Rent in Pune',
        headingDescription: 'Amruta Travels offers 40 Seater AC BharatBenz Bus on Rent in Pune, providing a premium and reliable travel experience for mid-to-large groups. Whether it’s a business tour, wedding transport, school trip, or religious yatra, our air-conditioned 40-seater BharatBenz buses ensure your group enjoys a safe, comfortable, and stress-free journey.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Located around 120 km from Pune, Mahabaleshwar is a scenic hill station famous for its strawberry farms, lush valleys, and viewpoints like Arthur’s Seat and Wilson Point. It's an ideal spot for nature lovers and weekend getaways."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range are popular for their green valleys, monsoon waterfalls, and attractions like Bhushi Dam and Tiger’s Leap. Great for a quick escape from city life."
  },
  {
    "title": "Shirdi",
    "description": "About 190 km from Pune, Shirdi is a major pilgrimage town dedicated to Sai Baba. The Sai Baba Temple attracts millions of devotees annually. The spiritual atmosphere makes it perfect for religious tourism."
  },
  {
    "title": "Goa",
    "description": "Located nearly 450 km from Pune, Goa is the ultimate beach holiday destination. From vibrant nightlife and water sports to heritage forts and churches, Goa offers something for every traveler."
  },
  {
    "title": "Nashik",
    "description": "Around 210 km from Pune, Nashik is known for its religious significance and as India’s wine capital. Key attractions include the Kalaram Temple, Sula Vineyards, and Trimbakeshwar Temple."
  },
  {
    "title": "Alibaug",
    "description": "Situated 140 km away, Alibaug is a coastal town with serene beaches like Nagaon and historical forts such as Kolaba Fort. It’s a popular choice for beach lovers and family picnics."
  },
  {
    "title": "Kolhapur",
    "description": "Roughly 235 km from Pune, Kolhapur is home to the famous Mahalaxmi Temple and is known for its rich cultural heritage and spicy cuisine. It also offers attractions like Rankala Lake and Panhala Fort."
  },
  {
    "title": "Lavasa",
    "description": "Just 60 km from Pune, Lavasa is a planned city nestled in the Western Ghats, offering lakeside views, water sports, and a peaceful retreat. Perfect for a one-day outing or weekend stay."
  },
  {
    "title": "Satara & Kaas Plateau",
    "description": "About 120 km from Pune, Satara is a gateway to the Kaas Plateau, a UNESCO-listed biodiversity hotspot. Visit during the monsoon to witness a stunning bloom of wildflowers across the valley."
  },
  {
    "title": "Aurangabad",
    "description": "Situated 235 km from Pune, Aurangabad is known for the Ajanta and Ellora Caves (UNESCO World Heritage Sites), Bibi Ka Maqbara, and Daulatabad Fort. A must-visit for history and architecture enthusiasts."
  }
],

 "services": [
    {
      "name": "40 Seater AC Bharat Benz Hire",
      "description": "Amruta Travels offers 40-seater AC Bharat Benz buses on hire in Pune. Ideal for corporate outings, weddings, and group travel, our buses provide a premium travel experience with air conditioning and spacious seating."
    },
    {
      "name": "Rent 40 Seater AC Bharat Benz in Pune",
      "description": "Looking for a comfortable and reliable travel option for a large group? Rent a 40-seater AC Bharat Benz in Pune from Amruta Travels for weddings, events, or outstation trips."
    },
    {
      "name": "40 Seater Bharat Benz Bus Rental",
      "description": "Choose Amruta Travels for 40-seater Bharat Benz bus rentals. Our buses are equipped with modern amenities and experienced drivers to ensure a smooth journey for any occasion."
    },
    {
      "name": "40 Seater Bharat Benz for Corporate Event",
      "description": "Organizing a corporate event? Book a 40-seater Bharat Benz AC bus with Amruta Travels for comfortable employee or guest transport, ensuring punctuality and convenience."
    },
    {
      "name": "40 Seater Bharat Benz for Wedding in Pune",
      "description": "Make wedding transportation effortless with a 40-seater Bharat Benz bus from Amruta Travels. Perfect for moving guests in comfort and style to and from venues across Pune."
    }
  ],
  "tableData": [
    ["40 Seater AC Bharat Benz Hire", "Rent 40 Seater AC Bharat Benz in Pune"],
    ["40 Seater Bharat Benz Bus Rental", "40 Seater Bharat Benz for Corporate Event"],
    ["40 Seater Bharat Benz for Wedding in Pune"]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Luxurious 40 Seater AC Bharat Benz on Rent in Pune",
    "WhyChoosedescription": "Amruta Travels offers the luxurious 40 Seater AC Bharat Benz buses for rent in Pune, providing an exceptional travel experience for medium to large groups. Whether you’re planning a corporate outing, wedding transportation, or a long-distance trip, these buses offer premium comfort and performance."
  },
  {
    "WhyChooseheading": "Perfect for Corporate Events, Weddings, and Group Tours",
    "WhyChoosedescription": "Our 40 Seater AC Bharat Benz buses are ideal for large groups attending corporate events, weddings, family vacations, or school trips. With spacious seating and modern amenities, these buses ensure a comfortable and stylish ride for all passengers."
  },
  {
    "WhyChooseheading": "Modern Features for Maximum Comfort and Convenience",
    "WhyChoosedescription": "The 40 Seater AC Bharat Benz buses are equipped with plush, reclining seats, powerful air conditioning, individual charging ports, entertainment systems, and generous luggage space. These features provide a smooth, relaxing ride for both short and long-distance journeys."
  },
  {
    "WhyChooseheading": "Affordable Luxury with Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers affordable, transparent pricing for 40 Seater AC Bharat Benz bus rentals in Pune. Our all-inclusive rates cover fuel, tolls, driver charges, and taxes—no hidden costs, giving you peace of mind while planning your group trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Punctual Journeys",
    "WhyChoosedescription": "Our 40 Seater AC Bharat Benz buses are driven by experienced, licensed drivers who ensure a safe, smooth, and timely journey. They are familiar with local and outstation routes, ensuring you reach your destination on time, every time."
  },
  {
    "WhyChooseheading": "Ideal for Long-Distance and Local Group Travel",
    "WhyChoosedescription": "Whether you're heading on a local city tour or a long-distance journey to destinations like Shirdi, Lonavala, or Mahabaleshwar, our 40 Seater AC Bharat Benz buses offer the ideal balance of comfort, space, and reliability for every type of trip."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for Safe and Reliable Travel",
    "WhyChoosedescription": "We ensure that our 40 Seater AC Bharat Benz buses are regularly maintained and inspected for safety and performance. Our buses are thoroughly cleaned and prepped before every trip to ensure a smooth and hassle-free journey for your group."
  },
  {
    "WhyChooseheading": "Easy Booking and 24/7 Customer Support",
    "WhyChoosedescription": "Booking a 40 Seater AC Bharat Benz bus with Amruta Travels is simple and hassle-free. You can book online, over the phone, or visit our office in person. Our 24/7 customer support is always available to assist with bookings, itinerary planning, and any last-minute changes."
  }
]





















    }

const faqData = [
  {
    question: 'Can I rent a 40-seater AC Bharat Benz bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers 40-seater AC Bharat Benz buses for rent in Pune. These buses are ideal for medium to large groups, corporate events, school outings, family functions, and outstation tours.',
  },
  {
    question: 'What features are available in the 40-seater AC Bharat Benz bus?',
    answer: 'Our 40-seater AC Bharat Benz buses come equipped with comfortable push-back seats, air conditioning, ample legroom, large windows for a great view, a high-quality sound system, and spacious luggage compartments for a smooth and enjoyable journey.',
  },
  {
    question: 'Is the 40-seater AC Bharat Benz available for both local and outstation trips?',
    answer: 'Yes, the 40-seater AC Bharat Benz bus is available for local travel within Pune and for outstation trips to popular destinations like Shirdi, Mahabaleshwar, Lonavala, Goa, and beyond.',
  },
  {
    question: 'Does the rental include a driver?',
    answer: 'Yes, all our rentals for the 40-seater AC Bharat Benz include an experienced and licensed driver who will ensure the safety and comfort of your group throughout the trip.',
  },
  {
    question: 'How much does it cost to rent a 40-seater AC Bharat Benz in Pune?',
    answer: 'The cost of renting a 40-seater AC Bharat Benz depends on the duration, distance, and type of trip. Typically, the rates start from ₹38–₹45 per km. Please contact us for a customized quote based on your specific requirements.',
  },
  {
    question: 'Is the 40-seater AC Bharat Benz bus suitable for long-distance travel?',
    answer: 'Yes, the 40-seater AC Bharat Benz bus is perfect for long-distance travel. It is designed to offer maximum comfort, with spacious seating, air conditioning, and a smooth ride, making it ideal for extended journeys.',
  },
  {
    question: 'Are the 40-seater AC Bharat Benz buses well-maintained and sanitized?',
    answer: 'Yes, all our buses, including the 40-seater AC Bharat Benz, are thoroughly cleaned and sanitized before every trip to ensure that passengers enjoy a hygienic, comfortable, and safe travel experience.',
  },
  {
    question: 'How can I rent a 40-seater AC Bharat Benz in Pune?',
    answer: 'You can easily rent a 40-seater AC Bharat Benz by booking online through our website or by contacting our customer service team. We provide quick, hassle-free booking and are happy to assist you with all the details for your trip.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sachin Bhosale',
    role: 'Business Executive, Pune',
    text: 'We hired a 40-seater AC Bharat Benz bus for a company outing, and it was a great experience. The bus was clean, comfortable, and the driver was professional. I would highly recommend Amruta Travels!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sunita Khare',
    role: 'Event Planner',
    text: 'Amruta Travels provided us with a 40-seater AC Bharat Benz bus for transporting guests to a wedding event. The bus was spacious and well-maintained. The guests were very comfortable throughout the journey.',
    rating: 5,
  },
];





















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const acBharatBenz40SeaterSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "40 Seater AC Bharat Benz on Rent in Pune",
  "description": "Rent a 40 seater AC Bharat Benz bus in Pune for weddings, corporate events, and group travel. Premium comfort and reliable transportation for outstation and local use.",
  "image": "https://bushireinpune.com/assets/images/40-seater-bharat-benz-ac.jpg", // Replace with actual image URL
  "provider": {
    "@type": "LocalBusiness",
    "name": "Amruta Travels",
    "url": "https://bushireinpune.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "India"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-XXXXXXXXXX", // Add actual number
      "contactType": "Customer Service"
    }
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://bushireinpune.com/40-seater-ac-bharat-benz-on-rent-in-pune",
    "priceCurrency": "INR",
    "price": "16000", // Example base rate, update as needed
    "availability": "https://schema.org/InStock",
    "validFrom": "2024-01-01"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "reviewCount": "87"
  }
};




    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | 40 Seater AC Bharat Benz on Rent in Pune | Corporate & Wedding Bus Rental</title>
  <meta 
    name="description" 
    content="Book 40 Seater AC Bharat Benz in Pune for weddings, corporate trips, and local or outstation travel. Spacious and comfortable bus rental with experienced driver." 
  />
  <script type="application/ld+json">
    {JSON.stringify(acBharatBenz40SeaterSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/18.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Fourtyseater;